export const STUDENT_INFO = "/student-info-sb/v0";
export const STUDENT_INFO_BUS_ROUTE = `${STUDENT_INFO}/student/bus_route`; // /{$studentNumber}/detail.json
export const STUDENT_INFO_CUSTOM_ATTRIBUTES = `${STUDENT_INFO}/custom_student`; // /{studentNumber}/index.json
export const STUDENT_INFO_STUDENT = `${STUDENT_INFO}/student`;
export const STUDENT_INFO_HOME_SCHOOL = `${STUDENT_INFO}/enrollment/home_school`; // /{personId}/{schoolId}/check.json
export const STUDENT_INFO_GUARDIAN = `${STUDENT_INFO}/guardian`;
export const STUDENT_INFO_GUARDIAN_CONTACT_UPDATE = `${STUDENT_INFO_GUARDIAN}/updateContact/detail.json`;
export const STUDENT_INFO_REFERENCE_DATA = `${STUDENT_INFO}/reference_data/campus_dictionary`; // {attributeName}/{objectName}/index.json
export const STUDENTS_BY_GUARDIAN_GET = `${STUDENT_INFO}/guardian/students`; // /{userName}/index.json

export const CUSTOM_STUDENT_ATTRIBUTE_IDS_PRI = {
    921: "check_online"
};

export const CUSTOM_STUDENT_ATTRIBUTE_IDS_SEC = {
    1281: "check_online_sec"
};

export const getAttributeIds = (primSecFlag: string): Record<number, string> | null => {
    if (primSecFlag === "PRIMARY") {
        return CUSTOM_STUDENT_ATTRIBUTE_IDS_PRI;
    }
    if (primSecFlag === "SECONDARY") {
        return CUSTOM_STUDENT_ATTRIBUTE_IDS_SEC;
    }

    return null;
};
